import { render } from "./AdminViewPaymentLiquidation.vue?vue&type=template&id=5f80f63a"
import script from "./AdminViewPaymentLiquidation.vue?vue&type=script&lang=js"
export * from "./AdminViewPaymentLiquidation.vue?vue&type=script&lang=js"

import "./AdminViewPaymentLiquidation.vue?vue&type=style&index=0&id=5f80f63a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__